import React, { useEffect, useMemo } from 'react';
import { TBannerLocation } from '../banners.t';
import { useMakeSelector } from '../../../hooks/useMakeSelector';
import { makeSelectBannersListByLocation } from '../bannersSelectors';
import { useDispatch } from 'react-redux';
import { bannersSlice } from '../bannersReducer';
import BannerContainer from '../PromoBanner/BannerContainer';

interface IUseBannersListProps {
    location: TBannerLocation,
    short?: boolean,
}

function useBannersList(props: IUseBannersListProps) {
    const { location, short } = props;
    const promoBannerList = useMakeSelector(makeSelectBannersListByLocation, [location]);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(bannersSlice.actions.initBannersAction());
    }, [dispatch]);

    return useMemo(() => promoBannerList.map(banner => (
        <BannerContainer key={banner.name} data={banner} short={short} location={location}/>
    )), [location, promoBannerList, short]);
}

export default useBannersList;
